import { baseApiService } from "./baseApiService";

// Company interfaces matching backend DTOs
export interface CompanyDto {
  id: string;
  name: string;
  address?: string;
  companyDomain?: string;
  logo?: string;
  phoneNumber?: string;
  description?: string;
  email?: string;
  active: boolean;
  symbolsCount?: number;
}

export interface CreateCompanyDto {
  name: string;
  address?: string;
  companyDomain?: string;
  logoBase64?: string; // Accept base64 logo from frontend
  phoneNumber?: string;
  description?: string;
  email?: string;
}

export interface UpdateCompanyDto extends CreateCompanyDto {
  id: string;
}

export interface UpdateCompanyStatusDto {
  isActive: boolean;
}

// Company specific API calls
export const companyService = {
  // Get all companies
  getAll: () => baseApiService.get<CompanyDto[]>("/Company"),

  // Get company by ID
  getById: (id: string) => baseApiService.get<CompanyDto>(`/Company/${id}`),

  // Create new company
  create: (dto: CreateCompanyDto) => baseApiService.post<void>("/Company", dto),

  // Update company
  update: (dto: UpdateCompanyDto) => baseApiService.put<void>("/Company", dto),

  // Delete company
  delete: (id: string) => baseApiService.delete<void>(`/Company/${id}`),

  // Update company status
  updateStatus: (id: string, dto: UpdateCompanyStatusDto) =>
    baseApiService.patch<void>(`/Company/${id}/status`, dto),
};
